import React, { useContext, useEffect } from 'react'
import { PageTitle } from '../../layout/core'
import { Navigate, Route, Routes, Outlet } from 'react-router-dom'
import AllSubjectList from './AllSubjectList'
import Lesson from './Lesson'
import Topic from './Topic'

const ElearningPage: React.FC = () => {
  return (
    <>
      <div className='card card-flush mb-5'>
        <Routes>
          <Route element={<Outlet />}>
            <Route
              path='/all-subject'
              element={
                <>
                  <PageTitle breadcrumbs={[]}>E-Learning</PageTitle>
                  <AllSubjectList />
                </>
              }
            />

            <Route path='/class1' element={<Lesson />} />
            <Route
              path='/class1/:name'
              element={
                <>
                  <Topic />
                </>
              }
            />
            <Route index element={<Navigate to='/learning/all-subject' />} />
          </Route>
        </Routes>
      </div>
    </>
  )
}

export default ElearningPage
